<script>
    import transparenciaServico from '../../../servico';

    export default {
      components: { },
      data() {
        return {
          informacoesInstitucionais: [],
          configuracao: this.$storage.configuracao(),
        }
      },
      methods: {
        listaDeInformacoesInstitucionais() {
          return transparenciaServico
            .informacoesInstitucionais()
            .then(informacoesInstitucionais => {
              this.informacoesInstitucionais = informacoesInstitucionais
            });
        },
        verificarPagamento() {
          this.$router.push({
            name: 'transparencia.institucional.verificar.pagamento',
          });
        },
        informacaoInstitucionalDetalhe(id) {
          this.$router.push({
            name: 'transparencia.institucional.detalhar',
            params: { id },
          });
        },
        voltar() {
          this.$router.push({
            name: 'transparencia.projetos',
            query: this.$route.query
          });
        },
      },
      computed: {
      },
      async mounted() {
        if (!this.configuracao.acessarInstitucionalPortalTransparencia) {
          this.$router.push({
            name: 'transparencia.projetos',
            query: this.$route.query
          });
        }
        await this.listaDeInformacoesInstitucionais();
      }
    }
</script>

<template>
  <div>
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h3><b>Institucional</b></h3>
      </div>

            
      <div class="ibox-content">
        <div v-for="informacaoInstitucional in informacoesInstitucionais">
          <button class="btn btn-primary" type="button" 
                  v-if="informacaoInstitucional.nomePortalTransparencia === 'Verificação de pagamento'"
                  @click="verificarPagamento()">
            <i class="fa fa-search"></i> {{ informacaoInstitucional.titulo }}
          </button>

          <button class="btn btn-primary" type="button" v-else
                  @click="informacaoInstitucionalDetalhe(informacaoInstitucional.idPortalTransparencia)">
            <i class="fa fa-search"></i> {{ informacaoInstitucional.titulo }}
          </button>

          <br />
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/institucional/Institucional.vue